import * as React from "react";
const SvgFiRrMedal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-medal_svg__a)">
      <path
        fill="#062147"
        d="M22.21.939A1.98 1.98 0 0 0 20.52 0h-3.008a3.97 3.97 0 0 0-3.587 2.23l-1.861 3.773L12 6l-.041.002-1.861-3.772A3.97 3.97 0 0 0 6.512 0h-3.01a1.98 1.98 0 0 0-1.69.939A1.98 1.98 0 0 0 1.72 2.87L4.95 9.423A8.95 8.95 0 0 0 3 15.001c0 4.962 4.038 9 9 9s9-4.038 9-9a8.95 8.95 0 0 0-1.937-5.56l3.24-6.57A1.98 1.98 0 0 0 22.212.94zM6.51 2c.768 0 1.455.427 1.794 1.115l1.555 3.153a9 9 0 0 0-3.416 1.666L3.502 2zM12 22c-3.86 0-7-3.14-7-7 0-3.66 2.825-6.668 6.409-6.97h.004c.194-.016.39-.03.588-.03 3.86 0 7 3.14 7 7s-3.14 7-7 7zm5.57-14.055a9 9 0 0 0-3.41-1.672l1.558-3.158A1.99 1.99 0 0 1 17.51 2l3-.015zm-1.413 6.465c0 .361-.251.665-.54.825l-1.49.828.662 1.803a.845.845 0 0 1-1.308.958l-1.482-1.146-1.482 1.146a.845.845 0 0 1-1.308-.958l.66-1.803-1.49-.828c-.287-.16-.538-.464-.538-.825 0-.306.266-.644.696-.644h2.14l.567-2.175a.79.79 0 0 1 .755-.591.794.794 0 0 1 .755.591l.567 2.175h2.14c.43 0 .696.337.696.644"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-medal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMedal;
